import axios from "axios";
import router from "../router/index"
import {
	Toast
} from 'vant';
import {getAppid,DEFAULTAPPID} from './tool'
/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, params = {}) {
	const api_token = localStorage.getItem("token");
	if (api_token) {
		params.api_token = api_token
	}
  let appid = getAppid() ? getAppid() : DEFAULTAPPID;
  params.v = new Date().getTime();
  if(params.opcode){
    url = url+'?code='+params.opcode;
    delete params.opcode
  }
  if(params.openid){
    url = url+'?openid='+params.openid;
    delete params.openid
  }
	return new Promise((resolve, reject) => {
    const service = axios.create({
      baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
      // withCredentials: true, // send cookies when cross-domain requests
      timeout: 50000 // request timeout
  })
  service.post(url, params,{headers:{ appid: appid }})
			.then(res => {
				if (res.data.code == 0) {
					resolve(res.data);
				} else if (res.data.code == 401 && res.data.message === "未设置token") {
					localStorage.clear();
					router.replace({
						path: '/login',
						query: {
							redirect: router.currentRoute.fullPath
						}
					})
				} else {
					Toast({
						message: res.data.message,
						position: 'bottom',
					});
					reject(res)
				}
			})
			.catch(err => {
        Toast.clear()
        Toast({
          message: '网络异常',
          position: 'bottom',
        });
				reject(err.data)
			})
	});
}